
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.323","height":"11.367"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"eye (1)","opacity":".6"}},[_c('g',{attrs:{"data-name":"Сгруппировать 22578"}},[_c('g',{attrs:{"data-name":"Сгруппировать 22577"}},[_c('path',{attrs:{"data-name":"Контур 553","d":"M19.378 5.318C19.207 5.132 15.193.75 10.162.75S1.113 5.132.946 5.318a.548.548 0 000 .731c.167.186 4.184 4.568 9.216 4.568s9.049-4.382 9.216-4.568a.548.548 0 000-.731z","fill":"none","stroke":"#fff","stroke-width":"1.5"}})])]),_c('g',{attrs:{"data-name":"Сгруппировать 22580"}},[_c('g',{attrs:{"data-name":"Сгруппировать 22579"}},[_c('path',{attrs:{"data-name":"Контур 554","d":"M10.71 4.588a1.639 1.639 0 01.69-1.335 2.705 2.705 0 00-1.238-.31 2.741 2.741 0 102.694 3.2 1.635 1.635 0 01-2.146-1.555z","fill":"#fff"}})])])])])
          )
        }
      }
    